/* VELARA — core UI. No dependencies. */
(function () {
  'use strict';
  var d = document;
  var $ = function (s, r) { return (r || d).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); };

  /* ---- scroll reveal (CSS-driven; the GSAP layer only enhances) ---- */
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var animated = $$('[data-anim],[data-anim-stagger],.reveal-img');
  if (reduce || !('IntersectionObserver' in window)) {
    animated.forEach(function (el) { el.classList.add('is-in'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
    animated.forEach(function (el) { io.observe(el); });
  }

  /* ---- sticky header condenses on scroll ---- */
  var hdr = $('[data-header]');
  if (hdr) {
    var onScroll = function () { hdr.classList.toggle('is-stuck', window.scrollY > 12); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---- fullscreen mobile nav ---- */
  var mnav = $('[data-mnav]');
  function setNav(open) {
    if (!mnav) return;
    mnav.dataset.open = open ? 'true' : 'false';
    mnav.setAttribute('aria-hidden', open ? 'false' : 'true');
    d.body.style.overflow = open ? 'hidden' : '';
    var t = $('[data-mnav-open]');
    if (t) t.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) { var c = $('[data-mnav-close]'); if (c) c.focus(); }
  }
  d.addEventListener('click', function (e) {
    if (e.target.closest('[data-mnav-open]')) return setNav(true);
    if (e.target.closest('[data-mnav-close]')) return setNav(false);
  });
  d.addEventListener('keydown', function (e) { if (e.key === 'Escape') setNav(false); });

  window.VELARA = window.VELARA || {};
  window.VELARA.closeNav = function () { setNav(false); };
})();
